module.exports = __webpack_public_path__ + "img/compliance_gear.55ba48f2.png";